import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class CardLinkHelper  {
    _originalTypeClassName = "ekylikeio.BO.CardLinkHelper";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
CardLinkHelper.translate = translateService;
}
this.CardLinkHelperKey = null;
this._key = this.CardLinkHelperKey = 0; 
}

static translate: TranslateService;
_key: any;
private _CardLinkHelperKey:any;
get CardLinkHelperKey(): any {
    return this._CardLinkHelperKey;
  }
set CardLinkHelperKey(value: any) {
    this._CardLinkHelperKey = value;
    this._key = value;
  }

static GetOrderId(data: any): any{let sep = data?.orderid?.indexOf("T");
if (CLMS.Framework.Number.Equal(() => sep, () => -1)) {return 0;}
return CLMS.Framework.Integer.Parse(data?.orderid?.substr(0, sep));
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.CardLinkHelperKey == null || $this.CardLinkHelperKey == 0;
            }


}